<template>
  <v-card>
    <v-card-text class="pb-0">
      <v-layout wrap>
        <v-flex xs12>
          <v-select
            label="Column"
            :items="rules"
            v-model="selected.field"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
            label="Operator"
            :items="operator_list"
            v-model="selected.operator"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-text-field label="Value" v-model="selected.value"></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pt-0">
      <div>
        <v-btn color="red" small @click="$emit('delete_query')">delete</v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import qb from "../functions/query.builder";

function convert(dict_value) {
  var return_value = [];

  for (var key in dict_value) {
    if (dict_value.hasOwnProperty(key)) {
      return_value.push({
        text: key,
        value: dict_value[key]
      });
    }
  }

  return return_value;
}

const NUM_OPERATOR = convert(qb.NUM_OPERATOR);
const STR_OPERATOR = convert(qb.STR_OPERATOR);

export default {
  name: "FilterItem",
  props: {
    rules: {
      type: Array,
      required: true
    },
    query: Object
  },
  data() {
    return {
      operator_list: [],
      selected: {
        _key: "",
        field: "",
        operator: "",
        value: ""
      }
    };
  },
  watch: {
    "selected.field": function(val) {
      var rule = this.rules.find(rec => rec.value == val);

      //this.selected.operator = "";

      switch (rule.data_type) {
        case Number:
          this.operator_list = NUM_OPERATOR;
          break;
        case String:
          this.operator_list = STR_OPERATOR;
          break;
      }

      //   var temp = this.operator_list.find(
      //     item => item.value == this.selected.operator
      //   );

      //   if (!temp) {
      //     this.selected.operator = "";
      //   }
    }
  },
  methods: {},
  mounted() {
    this.selected = this.query;
  }
};
</script>

<style>
</style>
